import { 
  GET_DPP_YN,
  GET_DPP_YN_SUCCESS,
  SET_ADM_EMAIL_MANAGEMENT_ALERT_MESSAGE,
    SET_ADM_EMAIL_MANAGEMENT_ERROR,
    SET_ADM_EMAIL_MANAGEMENT_LOADING, 
    SET_ADM_EMAIL_MANAGEMENT_SUCCESS, 
    UPDATE_DPP_YN,
    UPDATE_DPP_YN_SUCCESS
} from "./actionTypes"

export const setAdmEmailManagementLoading = data => {
  return {
    type: SET_ADM_EMAIL_MANAGEMENT_LOADING,
    payload: data,
  }
}

export const setAdmEmailManagementSuccess = data => {
  return {
    type: SET_ADM_EMAIL_MANAGEMENT_SUCCESS,
    payload: data,
  }
}

export const setAdmEmailManagementError = data => {
  return {
    type: SET_ADM_EMAIL_MANAGEMENT_ERROR,
    payload: data,
  }
}

export const setAdmEmailManagementAlertMessage = data => {
  return {
    type: SET_ADM_EMAIL_MANAGEMENT_ALERT_MESSAGE,
    payload: data,
  }
}

export const getDppYn = data => {
  return {
    type: GET_DPP_YN,
    payload: data,
  }
}

export const getDppYnSuccess = data => {
  return {
    type: GET_DPP_YN_SUCCESS,
    payload: data,
  }
}

export const updateDppYn = data => {
  return {
    type: UPDATE_DPP_YN,
    payload: data,
  }
}

export const updateDppYnSuccess = data => {
  return {
    type: UPDATE_DPP_YN_SUCCESS,
    payload: data,
  }
}